import Repository from './Repository';

const quote_send_resource = 'finalQuoteRequest';


// api/geo/city?CountryId=14&ProvinceId=9611689


export default {
  
  quoteReport(payload) {
    return Repository.post(`${quote_send_resource}`, payload)
  },
};
